module.exports = __webpack_public_path__ + "media/images/icon-personal-plan-9fa548a9bc93096720fcb2bfcc36e0a0.svg";